<template>
	<div class="wrapper">
		<div class="main">
			<div>
				<nav>
					<div class="image">
						<img alt="logo" src="@/assets/yellow.svg" height="50" />
					</div>
					<div class="link desktop-menu">
						<router-link to="/">Головна</router-link>
						<router-link to="/about">Контакти</router-link>
						<router-link to="/products">Перелік продуктів</router-link>
						<router-link to="/guarantee">Гарантія якості</router-link>
					</div>
					<!-- Иконка бургера для мобильной версии -->
					<div class="burger-menu" :class="{ open: isMobileMenuOpen }" @click="toggleMobileMenu">
						<font-awesome-icon :icon="['fas', 'bars']" color="white" />
					</div>
					<div :class="{ 'mobile-menu': true, 'active': isMobileMenuOpen }">
						<div class="burger-menu" :class="{ open: isMobileMenuOpen }" @click="toggleMobileMenu">
							<font-awesome-icon :icon="['fas', 'times']" />
						</div>
						<router-link to="/">Головна</router-link>
						<router-link to="/about">Контакти</router-link>
						<router-link to="/products">Перелік продуктів</router-link>
						<router-link to="/guarantee">Гарантія якості</router-link>
					</div>
					<div class="basket">
						<button @click="onBasket">Кошик 🛒 </button>
					</div>
				</nav>

			</div>
			<div>
				<h1>ЗДОРОВ’Я УКРАЇНИ</h1>
				<div class="motto">Нутриціологія Фітотерапія Дієтологія</div>
			</div>
			<slot></slot>
			<div>
				<h5>© 2025 Авторські права охороняються законом!</h5>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MainMasterpage',
	data() {
		return {
			isMobileMenuOpen: false
		};
	},
	computed: {
		authParams() {
			const params = localStorage.getItem('authParam')
			return params ? JSON.parse(params) : null
		},
		userName() {
			return this.authParams?.userName
		}
	},
	methods: {
		toggleMobileMenu() {
			this.isMobileMenuOpen = !this.isMobileMenuOpen;
		},
		onLogout() {
			localStorage.removeItem('authParam')
			this.$router.push({
				name: 'login'
			})
		},
		onLogin() {
			this.$router.push({
				name: 'login'
			})
		},
		onBasket() {
			this.$router.push({ name: 'basket' });
		}
	},
}
</script>

<style lang="scss" scoped>
.main {
	display: flex;
	flex-direction: column;
	max-width: 1200px;
	margin: 0 auto;
	position: relative;

	h1 {
		color: yellow;
		background-color: blue;
		text-align: center;
		margin: 1px 0 0 0;
		padding: 7px 0 7px 0;
		letter-spacing: 1px;
	}

	.motto {
		background-color: yellow;
		text-align: center;
		color: blue;
		font-size: 24px;
		margin-bottom: 10px;
		border-radius: 0 0 30px 30px;
		padding: 10px 0 10px 0;
		letter-spacing: 0.5px;
	}

	h5 {
		text-align: center;
	}

	.tel {
		a {
			color: rgb(237, 243, 140);
		}
	}

	nav {
		padding: 10px;
		background-color: #89b82a;
		display: flex;
		justify-content: space-around;
		align-items: center;
		//position: relative;
		border-radius: 10px 10px 0 0;
		top: 0;
		z-index: 2;

		a {
			font-weight: bold;
			color: #eff1f3;
			font-size: 20px;
			text-decoration: none;

			&.router-link-exact-active {
				color: #dceb09;
			}
		}
	}

	.basket {

		button {
			padding: 5px 10px;
			background-color: #ebe8e8;
			color: rgb(32, 33, 36);
			border-radius: 15px;
			font-size: 16px;
			border: 2px solid rgb(0, 61, 0);
			cursor: pointer;
			transition: all 0.5s ease 0s;

			&:hover {
				background-color: #acabab;
			}
		}
	}

	.link {
		display: flex;
		flex-direction: row;
		gap: 25px;
	}

	.burger-menu {
		display: none;
	}

	/* Стили для мобильного меню */
	.mobile-menu {
		visibility: hidden;
		position: fixed;
		top: -100%;
		left: 0;
		width: 100%;
		background-color: whitesmoke;
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
		z-index: 99;
		opacity: 0;
		//transition: all 0.7s ease;
		/* Изменение свойства transition */
		transform: translateY(-100%);
	}

	.mobile-menu {
		transition: all 0.7s ease;
	}

	@media (max-width:580px) {

		.desktop-menu {
			display: none;
			/* Скрываем десктопное меню на мобильном устройстве */
		}

		.burger-menu {
			display: block;
			/* Показываем иконку бургера на мобильном устройстве */
			cursor: pointer;
			font-size: 20px;
		}

		.mobile-menu.active {
			visibility: visible;
			display: flex;
			flex-direction: column;
			gap: 30px;
			padding: 20px 10px 30px 10px;
			opacity: 1;
			top: 0;
			transform: translateY(0);
			//transition-delay: 0s;
		}

		nav {
			justify-content: space-between;
			align-items: flex-start;

			a {
				font-size: 22px;
				color: black;
			}
		}

		h1 {
			font-size: 22px;
		}

		.motto {
			font-size: 18px;
		}

		.image {
			display: none;
		}

		.tel {
			display: none;
		}
	}
}
</style>